import React from 'react';
import { Sparkles } from 'lucide-react';
import { usePaymentsConfig, formatBetaDate } from '@/lib/usePaymentsConfig';

// Shown wherever billing would appear while ENABLE_PAYMENTS=false.
const BetaBanner = ({ compact = false }) => {
  const cfg = usePaymentsConfig();
  if (cfg.payments_enabled) return null;
  return (
    <div data-testid="beta-banner" className={`rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-900 flex items-start gap-2 ${compact ? 'p-2 text-xs' : 'p-3 text-sm'}`}>
      <Sparkles size={compact ? 14 : 18} className="mt-0.5 flex-shrink-0 text-emerald-600" />
      <div>
        <p className="font-semibold">Fase Beta Gratuita Activa</p>
        <p className={compact ? 'text-[11px]' : 'text-xs'}>Acceso ilimitado sin coste hasta el {formatBetaDate(cfg.free_beta_until)}. No se realizará ningún cargo.</p>
      </div>
    </div>
  );
};

export default BetaBanner;
